import { render, staticRenderFns } from "./SimpleCashier.vue?vue&type=template&id=ebc79e42&scoped=true&"
import script from "./SimpleCashier.vue?vue&type=script&lang=js&"
export * from "./SimpleCashier.vue?vue&type=script&lang=js&"
import style0 from "./SimpleCashier.vue?vue&type=style&index=0&id=ebc79e42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebc79e42",
  null
  
)

export default component.exports